import AxisLines from "./AxisLines";
export default AxisLines;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/ourPartners/components/axisLines/index.js